<template>
    <div>
        <view-analytics-supplyers
            :currentRoute="currentRoute"
            :currentTitle="groupingEntitySingle ? groupingEntitySingle + ' условия' : ''"
            :tableTabs="tableTabs"
            :table-first-column="groupingEntityMulti"
        />
    </div>
</template>

<script>
/** Пока что вывожу клиент условия через операторов. В будущем компоненты могут измениться */
import ViewAnalyticsSupplyers from './ViewAnalyticsSupplyers';
import schemeApi from '../../schemes/schemeApi';
import schemeAnalytics from "../../schemes/schemeAnalytics";
import mixinGroupingEntity from "@/mixins/mixinGroupingEntity";
let {routeAnalyticsClientCondition} = schemeApi;
let {clientConditionsAnalyticsTabs} = schemeAnalytics;
export default {
    name: 'ViewAnalyticsClientCondition',
    components: {
        ViewAnalyticsSupplyers
    },
    mixins: [
      mixinGroupingEntity
    ],
    /**
     * Входные данные компонента
     * @property {string} currentRoute - текущий маршрут
     * @property {Object} tableTabs - табы
     */
    data: () => ({
        currentRoute: routeAnalyticsClientCondition,
        tableTabs: clientConditionsAnalyticsTabs,
    }),
}
</script>

<style lang="scss" scoped>

</style>